import { useState } from 'react'
import useResizeEventListener from 'src/hooks/useResizeEventListener.hook'

const useDynamicHeight = () => {
  const [height, setHeight] = useState(window.innerHeight)
  const setDynamicHeightHandler = () => {
    setHeight(window.innerHeight)
  }
  useResizeEventListener(setDynamicHeightHandler)
  return { deviceHeight: height }
}

export default useDynamicHeight
